(() => {
  let coachFilters = [];
  const applyFiltersBtn = document.querySelector('.btn-apply-filters');
  const clearFiltersBtn = document.querySelector('.btn-clear-filters');
  const coachesContainer = document.querySelectorAll('.coaches-container');
  const coachesInputs = document.querySelectorAll('.coach-filter input');
  const coachesEmpty = document.querySelector('.coaches-empty');
  const coachesDropdownBtn = document.querySelectorAll('.coaches-dropdown-btn');
  const coachesDropdownList = document.querySelectorAll(
    '.coaches-dropdown-list' 
  );
  const coachesDropdownLabel = document.querySelectorAll(
    '.coaches-dropdown-label'
  );
  const coachesBtnFilter = document.querySelector('.btn-filter');
  const coachesModal = document.querySelector('.coaches-modal');
  const coachesModalClose = document.querySelector('.coaches-modal-close');
  const btnDisabled = document.querySelectorAll('.btn.disabled');
  // apply filters btn click
  applyFiltersBtn.addEventListener('click', () => {
    coachFilters = [];
    const checkedInputs = document.querySelectorAll(
      '.coach-filter input:checked'
    );
    // add all checked radio buttons
    checkedInputs.forEach(checked => {
      coachFilters.push(checked.value);
    });
    applyFilters(coachFilters);
    // show/hide image if coaches are empty
    const coachesContainerHidden = document.querySelectorAll(
      '.coaches-container.hidden'
    );
    if (coachesContainer.length === coachesContainerHidden.length) {
      coachesEmpty.classList.remove('hidden');
    } else {
      coachesEmpty.classList.add('hidden');
    }
    coachesModal.classList.remove('expanded');
  });

  // clear filters
  clearFiltersBtn.addEventListener('click', () => {
    coachFilters = [];
    coachesContainer.forEach(e => {
      e.classList.remove('hidden');
    });
    coachesInputs.forEach(e => {
      e.checked = false;
    });
    coachesEmpty.classList.add('hidden');
    coachesDropdownBtn.forEach(e => {
      e.textContent = 'Please Select';
    });
    coachesModal.classList.remove('expanded');
  });

  // apply filters
  function applyFilters(filters) {
    coachesContainer.forEach(e => {
      filters.every(filter => e.dataset.filters.indexOf(filter) !== -1)
        ? e.classList.remove('hidden')
        : e.classList.add('hidden');
    });
  }

  // Filters dropdown click
  coachesDropdownBtn.forEach(dropdown => {
    dropdown.addEventListener('click', () => {
      if (!dropdown.nextElementSibling.classList.contains('expanded')) {
        coachesDropdownList.forEach(e => {
          e.classList.remove('expanded');
        });
        dropdown.nextElementSibling.classList.add('expanded');
      } else {
        dropdown.nextElementSibling.classList.remove('expanded');
      }
    });
  });

  // Close dropdown
  coachesDropdownLabel.forEach(label => {
    label.addEventListener('click', () => {
      coachesDropdownList.forEach(e => {
        e.classList.remove('expanded');
      });
      label.parentElement.parentElement.previousElementSibling.textContent =
        label.textContent;
    });
  });

  // Show filter on mobile
  coachesBtnFilter.addEventListener('click', () => {
    coachesModal.classList.add('expanded');
  });

  // Close filter on mobile
  coachesModalClose.addEventListener('click', () => {
    coachesModal.classList.remove('expanded');
  });

  // close dropdowns on window click
  window.addEventListener('click', function(e) {
    if (!e.target.matches('.coaches-dropdown-btn')) {
      coachesDropdownList.forEach(e => {
        e.classList.remove('expanded');
      });
    }
  });

  //disabled btn
  btnDisabled.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
    });
  });
})();
